export function getTour(data) {
    return {
      type: 'GET_TOUR',
      data
    }
}